import { render, staticRenderFns } from "./NewsLmz.vue?vue&type=template&id=79f3eab3"
import script from "./NewsLmz.vue?vue&type=script&lang=ts"
export * from "./NewsLmz.vue?vue&type=script&lang=ts"
import style0 from "./NewsLmz.vue?vue&type=style&index=0&id=79f3eab3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports